<script lang="ts">
  let {
    value,
  }: {
    value: unknown
  } = $props()

  const enabled = $derived(Boolean(value))
</script>

<span class={enabled ? 'widget-bool widget-bool-yes' : 'widget-bool widget-bool-no'}>
  {enabled ? 'Yes' : 'No'}
</span>
